import axios from 'axios';
import { handleError, handleResponse } from '../utils/ServideHelper';

const Method = {
    GET: 'get',
    POST: 'post',
    DELETE: 'delete',
};

const url = {
    relatorioSku: '/tony/relatorio/sku',
    downloadRelatorio: '/tony/relatorio/download',
    removerRelatorio: '/tony/relatorio/',
    versoes: '/capacityrule/versoes',
};

export const removeRelatorio = (id) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: url.removerRelatorio + id,
            method: Method.DELETE,
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};

export const clearFiles = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `/tony/relatorio/clearFiles`,
            method: Method.GET,
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};

export const getRelatorioSku = (id, user) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: url.relatorioSku,
            method: Method.GET,
            params: { id, user },
            timeout: 0,
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};

export const getVersoes = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: url.versoes,
            method: Method.GET,
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};
